<template>
  <transfer-score :score="punctualityRate" :inline="inline" type="arrival"></transfer-score>
</template>

<script setup lang="ts">
import { type DelayPrediction } from '~/types/fptfTypes'
import TransferScore from '~/components/JourneyDisplay/TransferScore.vue'
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'

const store = useMainStore()
const { punctualityLimitDuration } = storeToRefs(store)

const { prediction, inline = false } = defineProps<{
  prediction: DelayPrediction
  inline?: boolean
}>()

const punctualityRate = computed(() => {
  let rate = 0
  const maxIndex = Math.min(
    punctualityLimitDuration.value.asMinutes() + prediction.offset + 1,
    prediction.predictions.length
  )
  for (let i = 0; i < maxIndex; i++) {
    rate += prediction.predictions[i]
  }
  return rate
})
</script>
